import { Grid } from "@mui/material";
import React, { useState } from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import { orderData } from "../data";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useDispatch } from "react-redux";
import {
  resetDataComponent,
  updateDataComponent
} from "../../StateManagement/actions";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method,
  toTitleCase
} from "../../commonFunctions/CommonFunctions";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import clientconfig from "../../Config/clientConfig.json";

export const SettlementList: React.FC<any> = () => {
  const [orderId, setOrderID] = useState<any>();
  const [totalCount, setTotalCount] = useState<any>();
  const [filterChanged, setFilterChanged] = useState<any>(false);
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();

  const columns: IColumns[] = [
    {
      header: "Order#",
      fieldName: "orderNumber",
      type: "default",
      sortable: true,
      sortKey: "OrderNumber"
    },
    {
      header: "Name",
      fieldName: "customerName",
      type: "default"
      // sortable: true,
      // sortKey: "id"
    },

    { header: "Phone", fieldName: "phoneNumber", type: "default" },
    { header: "Is Home Delivery", fieldName: "homeDelivery", type: "default" },
    { header: "Status", fieldName: "orderStatus", type: "status" },
    {
      header: "Ordered On",
      fieldName: "orderDate",
      type: "date",
      sortable: true
    },
    {
      header: "Expected Delivery",
      fieldName: "deliveryDate",
      type: "date",
      sortable: true
    },
    {
      header: "Total Price",
      fieldName: "finalAmount",
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Delivered"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    ("handleclick");
  };
  const filterRows: IRows[] = [
    {
      label: "Order#",
      fieldName: "OrderNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "CustomerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Status",
      fieldName: "OrderStatus",
      type: "radio",
      operator: "eq",
      align: "horizontal",
      options: clientconfig.filtterStatusConfig.staticOptionData,
      rowDivision: 12
    }
  ];

  const handleFilterChange = (newFilters: any) => {
    dispatch(updateDataComponent("ordersGrid", { newFilters }));
    setFilterChanged(true);
    //setFilters(newFilters);
  };
  const source = {
    url: "orders/search",
    page: 1,
    pageSize: 10,
    filter: [
      { field: "OrderStatus", operator: "eq", value: "PAID" },
      // {
      //   field: "FranchiseId",
      //   operator: "eq",
      //   value: getLocalValue(LoacalVariables.FranchiseId)
      // }
    ],
    sort: []
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    if (data && data?.length > 0) {
      data?.map((item: any) => {
        item.homeDelivery = item?.isHomeDelivery ? "Yes" : "No";
        item.status = toTitleCase(item.orderStatus);
      });
      return data;
    }
  };
  const handlePayment = async (data: any) => {
    try {
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent("settlementGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const saveData = async (data: any) => {
    const request: any = {
      amount: data?.amount,
      paymentType: data?.paymentType
    };

    const response: any = await callAPI(``, Method.PUT, request);
    return response;
  };

  const handleAction = async (action: string, row: any) => {
    // if (action === "Add Payment") {
    //   setOrderID(row?.orderId)
    //   openPopUp(metadataPayment, handlePayment, "40rem");
    // }
  };
  return (
    <>
      {/* actions={[{
        type: 'filter', filterFields: filterRows, text: 'aa', onFilterChange(data) {
          handleFilterChange(data)
        },
      }]} */}
      <HeaderList
        title="Orders"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="settlementGrid"
            title="Settlements"
            headerType="HaderTopCornered"
            columns={columns}
            filterFields={filterRows}
            source={source}
            transFormData={transFormData}
            isFilterChanged={filterChanged}
            // data={orderListData}
            //  addButton={{ label: "New", color: "secondary" }}
            //onAddButtonClick={handleClick}
          />
        </Grid>
      </Grid>
    </>
  );
};
